// config/fire-config.js

import apiConfig from './apiConfig';
import { envMODE } from './envMode';
//DEV, STAGING or PROD

var defaultWalletDb = '';

let nftsFirebaseStorageUrl = '';

let newbucketlink1 = '';
let newbucketlink2 = '';
let serviceid = '';
var defaultUserDb = '';
let payMailUrl = '';
let walletId = '00000000-0000-0000-0000-000000000000';

let paymail_stag = '@staging.musicart.io';
let paymail_dev = '@dev333.musicart.io';
let paymail_prod = '@musicart.io';

//whatschain
const wocString1 = 'mainnet_';
const wocString2 = '1c40126abb';
const wocString3 = '9f2e63';
const wocString4 = 'caa96f67d01';
const wocString5 = '20f66';
let wockey = wocString1 + wocString2 + wocString3 + wocString4 + wocString5;

if (envMODE === 'DEV') {
  defaultUserDb = 'https://musicartdev-default-rtdb.firebaseio.com';
  defaultWalletDb = 'https://musicartdev-wallet.firebaseio.com/';
  nftsFirebaseStorageUrl = 'gs://musicartdev';
  newbucketlink1 = `https://firebasestorage.googleapis.com/v0/b/musicartdev.appspot.com/o/`;
  newbucketlink2 = `https://firebasestorage.googleapis.com/v0/b/musicartdev/o/`;
  apiConfig.defaults.headers.common['serviceId'] =
    '41cee713-3e90-4a7c-85a0-427673f2aa70';
  serviceid = '41cee713-3e90-4a7c-85a0-427673f2aa70';
  payMailUrl = paymail_dev;
} else if (envMODE === 'STAGING') {
  defaultUserDb = 'https://musicartstaging-default-rtdb.firebaseio.com';
  defaultWalletDb = 'https://wallet-stagging-musicart-temp.firebaseio.com/';
  newbucketlink1 = `https://firebasestorage.googleapis.com/v0/b/musicartstaging.appspot.com/o/`;
  newbucketlink2 = `https://firebasestorage.googleapis.com/v0/b/musicartstaging/o/`;
  nftsFirebaseStorageUrl = 'gs://musicartstaging';
  apiConfig.defaults.headers.common['serviceId'] =
    '987912d3-d7df-4b55-aa6f-72deedba4cd5';
  serviceid = '987912d3-d7df-4b55-aa6f-72deedba4cd5';
  payMailUrl = paymail_stag;
} else if (envMODE === 'PROD') {
  defaultUserDb = 'https://musicart-146af-default-rtdb.firebaseio.com';
  defaultWalletDb = 'https://wallet-musicart.firebaseio.com/';
  nftsFirebaseStorageUrl = 'gs://musicart-146af/';
  newbucketlink1 = `https://firebasestorage.googleapis.com/v0/b/musicart-146af.appspot.com/o/`;
  newbucketlink2 = `https://firebasestorage.googleapis.com/v0/b/musicart-146af/o/`;
  apiConfig.defaults.headers.common['serviceId'] =
    '174b40d7-5d2d-462c-85b8-6a2b58a6dab2';
  serviceid = '174b40d7-5d2d-462c-85b8-6a2b58a6dab2';
  payMailUrl = paymail_prod;
}

export const serverApi = 'https://api.relysia.com';

export const bucketlink1 = newbucketlink1;
export const bucketlink2 = newbucketlink2;
export const serviceId = serviceid;
export const envMode = envMODE;
export const paymailUrl = payMailUrl;
export const wocKey = wockey;
export const walletID = walletId;
